// src/admin/Drivers.jsx
import React, { useState } from "react";
import { Table, Button, Modal, Form, Input, Tag, Select, Space } from "antd";
import { UserAddOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { INITIAL_DRIVERS } from "../data/store";

const { Option } = Select;

const Drivers = () => {
  const [data,          setData]          = useState(INITIAL_DRIVERS);
  const [isModalOpen,   setIsModalOpen]   = useState(false);
  const [editingDriver, setEditingDriver] = useState(null);
  const [form] = Form.useForm();

  const handleAdd = () => {
    setEditingDriver(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const handleEdit = (record) => {
    setEditingDriver(record);
    form.setFieldsValue(record);
    setIsModalOpen(true);
  };

  const handleDelete = (key) => {
    setData(data.filter(d => d.key !== key));
  };

  const handleOk = () => {
    form.validateFields().then(values => {
      if (editingDriver) {
        setData(data.map(d => d.key===editingDriver.key ? { ...d, ...values } : d));
      } else {
        setData([...data, { key:Date.now(), trips:0, ...values }]);
      }
      setIsModalOpen(false);
    });
  };

  const columns = [
    {
      title:"#", key:"idx",
      render:(_,__,i) => <span style={{ fontWeight:600, color:"#9ca3af" }}>{i+1}</span>,
      width:50,
    },
    {
      title:"Driver",
      render: r => (
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ width:36, height:36, borderRadius:"50%", background:"linear-gradient(135deg,#f5c518,#d4a80f)", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, color:"#1a1a2e", fontSize:14, flexShrink:0 }}>{r.name[0]}</div>
          <div>
            <div style={{ fontWeight:700, color:"#1a1a2e" }}>{r.name}</div>
            <div style={{ fontSize:12, color:"#9ca3af" }}>{r.phone}</div>
          </div>
        </div>
      ),
    },
    { title:"Car",    dataIndex:"car",    key:"car" },
    {
      title:"Rating", dataIndex:"rating", key:"rating",
      render: r => <span style={{ fontWeight:700, color:"#d4a80f" }}>★ {r}</span>,
      sorter:(a,b) => a.rating - b.rating,
    },
    {
      title:"Trips",  dataIndex:"trips",  key:"trips",
      render: t => <span style={{ fontWeight:600 }}>{t?.toLocaleString?.() ?? t}</span>,
      sorter:(a,b) => (a.trips||0) - (b.trips||0),
    },
    {
      title:"Status", dataIndex:"status", key:"status",
      render: s => <Tag color={s==="Active"?"green":"red"}>{s}</Tag>,
      filters:[{text:"Active",value:"Active"},{text:"Inactive",value:"Inactive"}],
      onFilter:(val,r) => r.status===val,
    },
    {
      title:"Action", key:"action",
      render: record => (
        <Space>
          <Button type="primary" size="small" icon={<EditOutlined />} onClick={()=>handleEdit(record)}>Edit</Button>
          <Button danger       size="small" icon={<DeleteOutlined />} onClick={()=>handleDelete(record.key)}>Delete</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:22, fontWeight:800, color:"#1a1a2e", margin:0 }}>Drivers</h2>
          <p style={{ color:"#9ca3af", fontSize:13, marginTop:2 }}>{data.length} drivers registered</p>
        </div>
        <Button type="primary" icon={<UserAddOutlined />} onClick={handleAdd}
          style={{ background:"linear-gradient(135deg,#f5c518,#d4a80f)", border:"none", color:"#1a1a2e", fontWeight:700, borderRadius:8, height:38 }}>
          + Add Driver
        </Button>
      </div>

      <Table
        dataSource={data} columns={columns}
        rowKey="key"
        scroll={{ x:true }}
        pagination={{ pageSize:8 }}
        style={{ background:"#fff", borderRadius:16, overflow:"hidden" }}
      />

      <Modal
        title={<span style={{ fontWeight:700 }}>{editingDriver ? "✏️ Edit Driver" : "➕ Add New Driver"}</span>}
        open={isModalOpen} onOk={handleOk} onCancel={()=>setIsModalOpen(false)}
        okText="Save" okButtonProps={{ style:{ background:"#f5c518", borderColor:"#f5c518", color:"#1a1a2e", fontWeight:700 } }}
      >
        <Form form={form} layout="vertical" style={{ marginTop:16 }}>
          <Form.Item name="name"   label="Driver Name"   rules={[{required:true}]}><Input placeholder="e.g. Rajesh Kumar" /></Form.Item>
          <Form.Item name="car"    label="Car"           rules={[{required:true}]}><Input placeholder="e.g. Toyota Innova" /></Form.Item>
          <Form.Item name="phone"  label="Phone Number"  rules={[{required:true}]}><Input placeholder="10-digit mobile" maxLength={10} /></Form.Item>
          <Form.Item name="rating" label="Rating"        rules={[{required:true}]}><Input type="number" step="0.1" min={1} max={5} placeholder="e.g. 4.8" /></Form.Item>
          <Form.Item name="trips"  label="Total Trips">  <Input type="number" placeholder="e.g. 120" /></Form.Item>
          <Form.Item name="status" label="Status">
            <Select placeholder="Select status">
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Drivers;